import * as React from "react";
const SvgCheckmarkUnchecked = props => <svg width={20} height={20} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}><path d="m10 0a10 10 0 0 0-10 10 10 10 0 0 0 10 10 10 10 0 0 0 10-10 10 10 0 0 0-10-10zm0 2a8 8 0 0 1 8 8 8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8z" style={{
    fill: "currentcolor"
  }} /></svg>;
export default SvgCheckmarkUnchecked;